import { userConstants } from '../_constants';

export function user(state = {attributes:[]}, action) {
//	console.log('user reducer was called with state', state, 'and action', action)
  switch (action.type) {
    case userConstants.GET_USER_REQUEST:
      return {
				...state,
        loading: true
      };
    case userConstants.GET_USER_SUCCESS:
      return {
				...state,
				attributes: action.user
			};
    case userConstants.GET_USER_FAILURE:
      return { 
				...state,
        error: action.error
      };
    case userConstants.GET_USER_SESSION_REQUEST:
      return {
				...state,
        sessionLoading: true
      };
    case userConstants.GET_USER_SESSION_SUCCESS:
      return {
				...state,
				session: action.session
			};
    case userConstants.GET_USER_SESSION_FAILURE:
      return { 
				...state,
        error: action.error
      };
    case userConstants.GET_USER_ATTRIBUTES_REQUEST:
      return {
				...state,
        sessionLoading: true
      };
    case userConstants.GET_USER_ATTRIBUTES_SUCCESS:
      return {
				...state,
				attributes: action.attributes
			};
    case userConstants.GET_USER_ATTRIBUTES_FAILURE:
      return { 
				...state,
        error: action.error
      };
    case userConstants.GET_USER_WITH_ATTRIBUTES:
      return { 
				...state,
        session: action.session,
				attributes: action.attributes
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/user.js